import api from './axios';

export const connectionsAPI = {
  /**
   * Получить список активных подключений
   * @param {Object} params - Параметры запроса
   * @param {string} params.proxyId - Фильтр по ID прокси (опционально)
   * @returns {Promise} Список активных подключений
   */
  getActive: async (params = {}) => {
    const response = await api.get('/api/v1/connections/active', { params });
    return response.data;
  },

  /**
   * Получить ВСЕ активные подключения (для отладки)
   * @returns {Promise} Все активные подключения всех пользователей
   */
  getAllActive: async () => {
    const response = await api.get('/api/v1/connections/active/all');
    return response.data;
  },

  /**
   * Получить историю подключений
   * @param {Object} params - Параметры запроса
   * @param {string} params.proxyId - Фильтр по ID прокси (опционально)
   * @param {string} params.status - Фильтр по статусу (опционально)
   * @param {number} params.limit - Лимит записей (по умолчанию 100)
   * @param {number} params.offset - Смещение для пагинации (по умолчанию 0)
   * @returns {Promise} История подключений
   */
  getHistory: async (params = {}) => {
    const response = await api.get('/api/v1/connections/history', { params });
    return response.data;
  },

  /**
   * Получить информацию о конкретном подключении
   * @param {number} connectionId - ID подключения
   * @returns {Promise} Детальная информация о подключении
   */
  getById: async (connectionId) => {
    const response = await api.get(`/api/v1/connections/${connectionId}`);
    return response.data;
  }
};
